import { Switch } from 'react-router-dom'
import AuthRoute from 'ui/components/AuthRoute'
import UnidadeDetalhesPage from '../Cadastros/UnidadePages/Detalhes'
import UnidadeImportacaoPage from '../Cadastros/UnidadePages/Importacao'
import CriarEditarCondominio from './Detalhes'
import Listagem from './Listagem'
import { PermissaoEnum } from "core/resources/enums/permissao";

function CondominioPages() {
  return (
    <Switch>
      <AuthRoute path="/condominio" exact component={Listagem} />
      <AuthRoute
        path="/condominio/criar"
        exact
        component={CriarEditarCondominio}
        permissions={[PermissaoEnum.Backoffice.Condominios.Criar]}
      />
      <AuthRoute
        path="/condominio/:id"
        exact
        component={CriarEditarCondominio}
        permissions={[PermissaoEnum.Backoffice.Condominios.Editar]}
      />

      <AuthRoute
        path="/condominio/:tenant/unidades/importacao"
        exact
        component={UnidadeImportacaoPage}
        permissions={[PermissaoEnum.Backoffice.Condominios.Editar]}
      />

      <AuthRoute
        exact
        path="/condominio/:tenant/unidades/new"
        component={UnidadeDetalhesPage}
        permissions={[PermissaoEnum.Backoffice.Condominios.Editar]}
      />
      <AuthRoute
        exact
        path="/condominio/:tenant/unidades/:id"
        component={UnidadeDetalhesPage}
      />
    </Switch>
  )
}

export default CondominioPages
